import { Box } from "@mui/material";
import { DotLegalInformationTooltip } from "@dotlegal/dotlegal-ui-components";

interface DialogHeaderWithInformationProps {
    header: string;
    // Left out where the dialog is opened for editing, since the text explains what creating one does
    information?: string;
}

function DialogHeaderWithInformation({ header, information }: DialogHeaderWithInformationProps) {
    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
            {header}
            {information && <DotLegalInformationTooltip text={information} />}
        </Box>
    );
}

export default DialogHeaderWithInformation;
